import { AlertCircle } from "lucide-react-native";
import { useSettingsData } from "../../../../contexts/SettingsDataContext";
import AnimatedBottomBanner from "./animated-bottom-banner";

const TestCallActiveBanner = () => {
  const { isTestCallActive } = useSettingsData();
  if (!isTestCallActive) {
    return null;
  }
  return (
    <AnimatedBottomBanner
      visible={isTestCallActive}
      icon={AlertCircle}
      message="Settings cannot be modified during an active test call"
      colorScheme="secondary"
    />
  );
};

export default TestCallActiveBanner;
